import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/sustainability/importer/sustainabilityImporterSelectors';
import SustainabilityService from 'src/modules/sustainability/sustainabilityService';
import fields from 'src/modules/sustainability/importer/sustainabilityImporterFields';
import { i18n } from 'src/i18n';

const sustainabilityImporterActions = importerActions(
  'SUSTAINABILITY_IMPORTER',
  selectors,
  SustainabilityService.import,
  fields,
  i18n('entities.sustainability.importer.fileName'),
);

export default sustainabilityImporterActions;